import React from "react"

interface InputErrorProps {
    error?: string | null;
}

export class InputError extends React.PureComponent<InputErrorProps>{
    render() {
        return this.props.error ? <small className="text-danger">{this.props.error}</small> : <div />
    }
}